import React from 'react';
import './InsightsSection.css';

const InsightsSection = () => {
  const insights = [
    {
      title: 'Industry Trend 2024',
      description: 'Discover the latest trends shaping the interior design industry this year.'
    },
    {
      title: 'Sustainable Solutions',
      description: 'Learn about eco-friendly approaches to modern interior design.'
    },
    {
      title: 'Technology Integration',
      description: 'Explore how technology is revolutionizing interior spaces.'
    }
  ];

  return (
    <section className="insights-section">
      <div className="container">
        <h2 className="section-title">Spotlight Industry Insights</h2>
        <p className="section-description">
          Stay ahead with our curated insights and analysis from industry experts.
        </p>
        <div className="insights-grid">
          {insights.map((insight, index) => (
            <div key={index} className="insight-card">
              <h3 className="insight-title">{insight.title}</h3>
              <p className="insight-description">{insight.description}</p>
              <a href="#" className="insight-link">Read More</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsightsSection;

